import { Role } from 'lib';
import { OperationType, PageView } from 'lib/types';
import { userService } from './user.service';
import store from 'store';

const roleViewPermissions: Record<Role, PageView[]> = {
    master: [
        'register-roofer',
        'manage-traders',
        'register-trader',
        'register-roofer',
        'orders',
        'new-order',
        'settlements',
        'promotions',
        'isod',
        'cookie-policy',
        'news',
        'changePassword',
        'additional-tab',
        'settings'
    ],

    handlowiec: [
        'register-roofer',
        'orders',
        'new-order',
        'settlements',
        'promotions',
        'isod',
        'account',
        'cookie-policy',
        'news',
        'changePassword',
        'additional-tab',
        'settings'
    ],

    dekarz: [
        'promotions',
        'account',
        'cookie-policy',
        'news',
        'changePassword',
        'settings'
    ],

    nadzorca: [
        'orders',
        'cookie-policy',
        'changePassword',
        'settings'
    ]
};

const roleOperationPermissions: Record<Role, OperationType[]> = {
    master: [
        'editDefaultView',
        'manageOrder',
        'changePromotionDeliveryAdress',
        'viewSystemVersion'
    ],

    handlowiec: [
        'editDefaultView',
        'manageOrder'
    ],

    dekarz: [
        'editDefaultView'
    ],

    nadzorca: [
        'authorizeOrder'
    ]
};

const haveAccessToView = (view: PageView): boolean => {
    const user = userService.getUser();
    if (user === null) return false;

    const allowedViews = roleViewPermissions[user.role] || [];

    if (view === 'admin') return user.permissions.canAccessAdminPanel;

    if (allowedViews.includes(view)) {
        const state = store.getState();
        const viewEnabled = state.conf.menu;
        if (view === 'news') return viewEnabled.news;
        if (view === 'new-order') return viewEnabled.new_order;
        if (view === 'orders') return viewEnabled.orders;
        if (view === 'promotions') return viewEnabled.promotion;
        if (view === 'settlements') return viewEnabled.billings;
        if (view === 'isod') return viewEnabled.isod;
        if (view === 'settings') return viewEnabled.settings;
        if (view === 'account') return viewEnabled.account;
        if (view === 'additional-tab') return user?.permissions.canEditAdditionalTab || state.data.additionalTab.details.isVisible;
        return true;
    }
    return false;
};

const haveAccessToOperation = (operation: OperationType): boolean => {
    const user = userService.getUser();
    if (user === null) return false;

    const allowedOperations = roleOperationPermissions[user.role] || [];

    if (allowedOperations.includes(operation)) {
        if (operation === 'authorizeOrder') return user.authEnabled;
        return true;
    }
    return false;
};

const permissionService = {
    haveAccessToView,
    haveAccessToOperation
};

export default permissionService;
